import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Sparkles } from 'lucide-react';
export function FinalOffer() {
  return <section className="py-20 md:py-28 bg-gradient-to-b from-cream to-peach-light/50 relative overflow-hidden" data-id="element-105">
      <div className="absolute top-10 right-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-106">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-peach" data-id="element-107"></div>)}
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-110">
            🌸 CIERRE FINAL
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-6" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-111">
            Tu maternidad merece ser vivida con
            <span className="italic text-peach-dark" data-id="element-112"> más calma</span>
          </h2>

          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-113">
            No necesitás hacerlo perfecto. Pero sí merecés sentirte acompañada,
            entender lo importante, vivir esta etapa con tranquilidad y confiar
            un poco más en vos.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] shadow-2xl shadow-peach/20 border border-peach/20 overflow-hidden max-w-2xl mx-auto relative" data-id="element-114">
          <div className="absolute top-6 right-6 w-20 h-20 bg-peach text-white rounded-full flex flex-col items-center justify-center shadow-xl transform rotate-12 z-20" data-id="element-115">
            <span className="text-2xl font-bold leading-none" data-id="element-116">50%</span>
            <span className="text-xs font-bold tracking-widest mt-1" data-id="element-117">OFF</span>
          </div>

          <div className="bg-peach text-white text-center py-4 text-sm font-bold tracking-widest uppercase flex items-center justify-center gap-2" data-id="element-118">
            <Sparkles className="w-4 h-4" data-id="element-119" /> OFERTA ESPECIAL
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-120">
            <h3 className="font-serif italic text-peach-dark mb-2" style={{
            fontSize: 'clamp(2.5rem, 6vw, 4rem)'
          }} data-id="element-121">
              Florecer
            </h3>
            <p className="text-text-muted mb-6" data-id="element-122">
              6 capítulos + 4 bonus exclusivos
            </p>

            <div className="flex justify-center items-center gap-3 text-text-muted line-through text-lg mb-2" data-id="element-123">
              <span data-id="element-124">$39.980</span>
              <span data-id="element-125">+</span>
              <span data-id="element-126">$42.500</span>
            </div>

            <div className="flex justify-center items-end gap-2 text-text-dark mb-8" data-id="element-127">
              <span className="text-5xl md:text-7xl font-bold tracking-tight" data-id="element-128">
                $19.990
              </span>
              <span className="text-xl font-medium mb-2" data-id="element-129">ARS</span>
            </div>
            <p className="text-sm text-text-muted mb-10" data-id="element-130">
              Pago único · Acceso de por vida
            </p>

            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full px-8 py-5 bg-peach text-white font-bold rounded-full hover:bg-peach-dark transition-colors shadow-xl shadow-peach/30 text-xl mb-6 tracking-wide" data-id="element-131">
              QUIERO MI ACCESO AHORA
            </button>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-text-muted" data-id="element-132">
              <span className="flex items-center gap-1" data-id="element-133">
                <Shield className="w-4 h-4" data-id="element-134" /> Pago seguro
              </span>
              <span className="hidden sm:inline text-peach/30" data-id="element-135">•</span>
              <span className="flex items-center gap-1" data-id="element-136">
                <Clock className="w-4 h-4" data-id="element-137" /> Acceso en 5 min
              </span>
              <span className="hidden sm:inline text-peach/30" data-id="element-138">•</span>
              <span data-id="element-139">Garantía 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}